import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/parking_reliefs',
  component: Management,
  redirect: '/parking_reliefs/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/parking_reliefs/List'),
      meta: {
        auth: Auth.listParkingReliefs
      }
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/parking_reliefs/New'),
      meta: {
        auth: Auth.createParkingRelief
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/parking_reliefs/Edit'),
      meta: {
        auth: Auth.updateParkingRelief
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/parking_reliefs/DetailLayout'),
      meta: {
        auth: Auth.showParkingRelief
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/parking_reliefs/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showParkingRelief
          }
        },
        // 减免记录
        {
          path: 'parking_relief_records',
          component: () => import('@/views/parking_reliefs/details/ParkingReliefRecords'),
          meta: {
            tabName: 'parking_relief_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listParkingReliefRecords
          }
        },
        // 活码
        {
          path: 'parking_relief_codes',
          component: () => import('@/views/parking_reliefs/details/ParkingReliefCodes'),
          meta: {
            tabName: 'parking_relief_codes', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listParkingReliefCodes
          }
        }
      ]
    }
  ]
}
